import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import SydLabel, { hookFormErrorAdapter } from '../../../../../../commonDesign/SydLabel'
import SydSelect from '../../../../../../commonDesign/SydSelect'
import { useSearchStatusTemplates } from '../../../../../../../api/groups'
import Skeleton from '../../../../../../atoms/Skeleton'

function StatusTemplateSelect () {
  const form = useFormContext()
  const createNewReport = form.watch('createNewReport')

  const { data, isLoading } = useSearchStatusTemplates({})

  return (
    <Controller
      control={form.control}
      name='newTemplateId'
      rules={{
        required: {
          value: createNewReport,
          message: 'Template is required when creating a new report'
        }
      }}
      render={({ field, fieldState }) => (
        <SydLabel
          label='New Status Report Template'
          description='Select the template to use for the new report'
          error={hookFormErrorAdapter(form, fieldState)}
        >
          {isLoading ? (
            <Skeleton width='100%' height='36px' />
          ) : (
            <SydSelect
              {...field}
              label='Status Report Template'
              description='Select the template to use for the new report'
              placeholder='Select template...'
              options={data?.data?.map(template => ({
                label: template.name,
                value: template.statusTemplateId
              })) || []}
              size='sm'
            />
          )}
        </SydLabel>
      )}
    />
  )
}

export default StatusTemplateSelect
